import { render, staticRenderFns } from "./OServicio.vue?vue&type=template&id=3a02ab45&scoped=true&"
var script = {}
import style0 from "./OServicio.vue?vue&type=style&index=0&id=3a02ab45&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a02ab45",
  null
  
)

export default component.exports